import {
  CharityVettingUrlType,
  type CharityVettingUrlTypeValues,
} from 'features/charity-vetting/types/charityVettingTypes';

const basePath = '/charity-vetting/';
const getStartedPath = 'get-started';
const searchPath = 'search';
const contactDetailsPath = 'contact-details';
const manualContactDetailsPath = 'manual-contact-details';
const legalRepresentativePath = 'legal-representative';
const registrationPath = 'registration';
const donationPreferencesPath = 'donation-preferences';
const acceptAllFoodsPath = 'accept-all-foods';
const acceptAllNonFoodPath = 'accept-all-non-food';
const acceptAllFoodAndNonFoodPath = 'accept-all-food-and-non-food';
const foodHygienePath = 'food-hygiene';
const foodHygieneCertificatePath = 'food-hygiene-certificate';
const SubmitFoodHygieneCertificatePath = 'submit-food-hygiene-certificate';
const unwantedFoodPath = 'unwanted-food';
const preparationKitchenPath = 'preparation-kitchen';
const consumptionTypePath = 'consumption-type';
const haccpPath = 'haccp';
const haccpCertificatePath = 'haccp-certificate';
const pliCoverPath = 'public-liability-insurance-cover';
const pliPath = 'public-liability-insurance';
const socialAccountsPath = 'social-accounts';
const reviewDetailsPath = 'review-details';
const nifPath = 'nif';
const nipcPath = 'nipc';
const fiscalBenefitsPath = 'fiscal-benefits';
const authorisedFoodAidPath = 'authorised-food-aid';
const organisationPurposePath = 'organisation-purpose';
const organisationSpecificTypePath = 'organisation-specific-type';
const decreePublicationDatesPath = 'decree-publication-dates';
const arretePublicationDatePath = 'arrete-publication-date';
const organisationSituationPath = 'organisation-situation';
const organisationOtherOptionPath = 'organisation-other-option';
const agrementDatePath = 'agrement-date';
const sirenPath = 'siren';
const foodSafetyQThreePath = 'food-safety-question-three';
const foodSafetyManagementPlanDeclarationPath = 'food-safety-management-plan-declaration';
const haccpDeclarationPath = 'haccp-declaration';
const cifPath = 'cif';
const rgseaaQuestionPath = 'rgseaa-question';
const rgseaaPath = 'rgseaa';
const donationCertificatePath = 'donation-certificate';
const nipPath = 'nip';
const krsPath = 'krs';
const publicBenefitPath = 'public-benefit';
const charityNumberPath = 'charity-number';
const companyNumberPath = 'company-number';
const companyRegistrationPath = 'company-registration';
// `liabilityInsurancePath` must stay last: both chains end on it (see frDocuments).
const associationRegistrationPath = 'association-registration';
const foodAidHabilitationPath = 'food-aid-habilitation';
const foodEstablishmentDeclarationPath = 'food-establishment-declaration';
const foodSafetyTrainingCertificatePath = 'food-safety-training-certificate';
const liabilityInsurancePath = 'liability-insurance';

export const vettingPath = {
  basePath,
  getStartedPath,
  searchPath,
  contactDetailsPath,
  manualContactDetailsPath,
  legalRepresentativePath,
  registrationPath,
  foodHygienePath,
  foodHygieneCertificatePath,
  SubmitFoodHygieneCertificatePath,
  pliPath,
  pliCoverPath,
  nifPath,
  nipcPath,
  authorisedFoodAidPath,
  organisationPurposePath,
  organisationSpecificTypePath,
  decreePublicationDatesPath,
  arretePublicationDatePath,
  organisationSituationPath,
  organisationOtherOptionPath,
  agrementDatePath,
  sirenPath,
  foodSafetyQThreePath,
  foodSafetyManagementPlanDeclarationPath,
  haccpDeclarationPath,
  socialAccountsPath,
  reviewDetailsPath,
  donationPreferencesPath,
  acceptAllFoodsPath,
  acceptAllNonFoodPath,
  acceptAllFoodAndNonFoodPath,
  unwantedFoodPath,
  preparationKitchenPath,
  consumptionTypePath,
  haccpPath,
  haccpCertificatePath,
  fiscalBenefitsPath,
  cifPath,
  rgseaaQuestionPath,
  rgseaaPath,
  donationCertificatePath,
  nipPath,
  krsPath,
  charityNumberPath,
  companyNumberPath,
  companyRegistrationPath,
  publicBenefitPath,
  associationRegistrationPath,
  foodAidHabilitationPath,
  foodEstablishmentDeclarationPath,
  foodSafetyTrainingCertificatePath,
  liabilityInsurancePath,
};

const STEP_NAME_VALUES = new Set<string>(Object.values(CharityVettingUrlType));

const isStepName = (segment: string | undefined): segment is CharityVettingUrlTypeValues =>
  !!segment && STEP_NAME_VALUES.has(segment);

/**
 * Resolves the vetting step name from a route pathname. The last path segment
 * (e.g. `contact-details`) equals the corresponding CharityVettingUrlType value,
 * so we match the trailing segment against the full set of step names. This
 * covers every routed page, so each resolves to its real step name (and thus
 * its validation schema). Step ordering and branching live in
 * `utils/charityVettingFlow.ts`.
 */
export const getStepNameFromPath = (pathname: string): CharityVettingUrlTypeValues | undefined => {
  const segment = pathname.split('/').filter(Boolean).at(-1);
  return isStepName(segment) ? segment : undefined;
};
